
import React, { useState, useEffect } from 'react';
import alarmGif from "app/assets/alarm.gif";
import "./Notification.scss";

/**
 * Sanitizes an HTML string to allow only safe tags and attributes.
 * Removes <script> tags, event handlers, and javascript: URLs.
 * For production, use DOMPurify for robust sanitization.
 */
function sanitizeHtml(html) {
  // Remove <script> tags and their content
  let clean = html.replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '');

  // Remove event handler attributes (e.g., onclick, onerror)
  clean = clean.replace(/ on\w+="[^"]*"/gi, '')
    .replace(/ on\w+='[^']*'/gi, '');

  // Remove javascript: in href/src
  clean = clean.replace(/(href|src)\s*=\s*(['"])javascript:[^'"]*\2/gi, '$1="#"');

  return clean;
}

const Notification = ({ notification, onClose }) => {
  if (!notification) return null;
  if (notification.title === "" && notification.message === "") return null;

  const closeNotification = () => {
    onClose()
  }

  return (
    <div className={`notification success ${notification.type === 'Warning' || notification.type === 'Alarm' ? 'notification-warning' : ''}`}>
      <div className="icon">
        {notification.type === 'Alarm' &&
          <img src={alarmGif} style={{ width: '22px' }} />
        }
        {notification.type !== 'Alarm' &&
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
            strokeLinecap="round" strokeLinejoin="round" className="feather feather-check-circle">
            <circle cx="12" cy="12" r="10"></circle>
            <path d="M9 12l2 2l4 -4"></path>
          </svg>
        }
      </div>
      <div className="content">
        {notification.title &&
          <div className="title">{notification.title}</div>
        }
        {notification.message &&
          <div
            className="message"
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(notification.message) }}
          />
        }
      </div>
      <div className="btn-close" onClick={closeNotification}>×</div>
    </div>
  )
}

export default Notification;